import React from 'react';

function ExpanderContainer({ children, expanded, className }) {
  return (
    <div className={`expander ${expanded && 'expanded'} ${className}`}>
      <div className="expander-content">
        {children}
      </div>
    </div>
  );
}

export default ExpanderContainer;
